/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */


import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { base_path, bucketObj } from "../../environment";
import axios from "axios";
// import crypto from 'crypto-browserify';
// const crypto = require('crypto')

import { getUrls } from "../../api/apiurls";

const { S3Client, PutObjectCommand, DeleteObjectCommand } = require("@aws-sdk/client-s3");

// const s32 = new S3Client({ region: 'me-central-1' });
var accessKeyId = 'AKIA6FR66A3CUJTGB6XM';//'AKIAXWQHQYREAJI2RFGB'
var secretAccessKey = 'KANBD/fpuabOyEuXzvaRgioJrYfWL++e24Ik0cz9';//'188/xU8oWg9efgwPj2VTvYTzl/a1D/5H9Qzk3HQm'


const s3 = new S3Client({
  region: "me-central-1", // e.g., 'ap-northeast-1'
  credentials: {
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey,
  }
});


export async function getImage(name) {
  let resp2 = await axios.get(`${getUrls().sso}/api/getUploadedContentUrl?filename=${name}`)
//  resp2.data.response.url = resp2.data?.response?.url.replace("https", "http");
  resp2.data.response.url = resp2.data?.response?.url.replace(/^https/, "http");
  let resp3 = await axios.get(resp2.data?.response?.url, {
    headers: {
      'Skip-Auth': 'true'
    }
  });
  return resp3.data;
}

export async function getImageURL(name) {
  let resp2 = await axios.get(`${getUrls().sso}/api/getUploadedContentUrl?filename=${name}`)
  let resp3 = await axios.get(resp2.data?.response?.url, {
    headers: {
      'Skip-Auth': 'true'
    }
  })
  return resp3.data;
}
function uniqueString({ tenantId, platform, category, name, type }) {
  const length = 7;
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    randomString += charset[randomIndex];
  }

  const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '').slice(0, 14); // e.g., 20250515T153210
  const extension = name && name.includes('.') ? name.substring(name.lastIndexOf('.')) : '';

  const randomName = `${tenantId || 'all'}/${platform || 'stocks'}/${category || 'category'}/${type || "img"}/${timestamp}_${randomString}${extension}`;
  
  return randomName;
}

function uniqueString2({ id, tenantId, platform, category, name, type, docKey }) {
  const extension = name && name.includes('.') ? name.substring(name.lastIndexOf('.')) : '';

  const randomName = `${tenantId || 'all'}/${platform || 'stocks'}/${category || 'category'}/${type || "img"}/${id}_${docKey}${extension}`;

  return randomName;
}
// function uniqueString2({ length, userId, tenantId, name, platform, app, module }) {
//   const mergeStringsRandomly = (str1, str2) => {
//     const currentDate = new Date().toLocaleString(); // Get current date/time as a string
//     const arr1 = Array.from(str1.replace(/[ :\/,]/g, '')); // Convert string 1 to array of characters, excluding spaces, colons, slashes, and commas
//     const arr2 = Array.from(str2.replace(/[ :\/,]/g, '')); // Convert string 2 to array of characters, excluding spaces, colons, slashes, and commas
//     const arrDate = Array.from(currentDate.replace(/[ :\/,]/g, '')); // Convert current date/time string to array of characters, excluding spaces, colons, slashes, and commas
//     const combinedArray = arr1.concat(arr2).concat(arrDate);

//     function shuffleArray(array) {
//       for (let i = array.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [array[i], array[j]] = [array[j], array[i]];
//       }
//       return array;
//     }

//     const shuffledArray = shuffleArray(combinedArray);
//     const mergedString = shuffledArray.join('');
//     return mergedString;
//   };

//   length = length || 15;
//   name = name ? `_${name}` : '';

//   platform = platform || 'inventory/';
//   app = app ? `${app}/` : '';
//   module = module ? `${module}/` : '';

//   module = tenantId ? `${module}${tenantId}/` : '';
//   module = userId ? `${module}${userId}/` : '';

//   const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//   let randomString = '';
//   for (let i = 0; i < length; i++) {
//     const randomIndex = Math.floor(Math.random() * charset.length);
//     randomString += charset[randomIndex];
//   }

//   if (userId && tenantId) {
//     let s1 = mergeStringsRandomly(userId, tenantId);
//     randomString = mergeStringsRandomly(s1, randomString);
//   }

//   return `${platform}${app}${module}${randomString}${name}`;
// }

export function getImageName(name, category, type) {
  const tenantId = localStorage.getItem("tenantId") || 'all';

  const randomString = uniqueString({
    tenantId,
    platform: 'stocks',
    category: category || 'socailmedia',
    name: name || 'ReactPhotoCollage.png',
    type: type || 'img'
  });

  return randomString;
}


export function getVideoName(name, category) {

  //const randomString = uniqueString({length: 10, userId: '', tenantId: '', name: "Video.mp4", platform: '', app: 'web', module: 'sooqista'})
  
  const tenantId = localStorage.getItem("tenantId") || 'all';

  const randomString = uniqueString({
    tenantId,
    platform: 'stocks',
    category: category || 'socailmedia',
    name: name || 'Video.mp4'
  });

  return randomString;
}

export async function uploadImageNewWithName(file, name) {

  if (!file) {
    alert('Please select a file.');
    return;
  }
  const objectKey = bucketObj.objectKey + name; // Specify the path within the bucket (optional)

 const uploadUrl = `${bucketObj.bucketUrl}${objectKey}`;
  try {
    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    });

    if (uploadResponse.ok) {
      console.log('File uploaded successfully', randomString );
      return randomString
    } else {
      console.error('Error uploading file:', uploadResponse.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}
export async function uploadVideoWithName(file, name) {

  if (!file) {
    alert('Please select a file.');
    return;
  }
  const objectKey = bucketObj.objectKey + name; // Specify the path within the bucket (optional)

 const uploadUrl = `${bucketObj.bucketUrl}${objectKey}`;
  try {
    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type
      }
    });

    if (uploadResponse.ok) {
      console.log('File uploaded successfully', randomString );
      return randomString
    } else {
      console.error('Error uploading file:', uploadResponse.statusText);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

export async function uploadImageNew2(file, category, type, opts = {}) {
  const { onProgress, signal } = opts; // NEW: optional progress + cancel

  if (!file) {
    alert("Please select a file.");
    return;
  }

  const tenantId = localStorage.getItem("tenantId") || "all";

  const randomString = uniqueString({
    tenantId,
    platform: "stocks",
    category: category || "category",
    name: file.name || "ReactPhotoCollage.png",
    type: type || "img",
  });

  const objectKey = randomString;
  const bucketName = "res.public"; // unchanged

  // Use the Blob/File directly — lets S3/client stream efficiently
  const uploadParams = {
    Bucket: bucketName,
    Key: "uploads/" + objectKey,
    Body: file,                       // <— pass the File/Blob (not Uint8Array)
    ContentType: file.type || "image/jpeg",
  };

  // Managed uploader with progress
  const uploader = new Upload({
    client: s3,                       // your existing S3 client
    params: uploadParams,
    queueSize: 4,                     // parallel parts
    partSize: 5 * 1024 * 1024,        // 5MB parts
    leavePartsOnError: false,
  });

  // Wire up cancel: if caller aborts, stop the upload
  if (signal) {
    if (signal.aborted) {
      // already aborted—bail early
      throw new DOMException("Aborted", "AbortError");
    }
    const abortHandler = () => uploader?.abortController?.abort();
    signal.addEventListener("abort", abortHandler, { once: true });
  }

  // Progress events
  const total = file.size || undefined;
  if (typeof onProgress === "function") {
    uploader.on("httpUploadProgress", (e) => {
      // e.loaded is cumulative bytes; e.total sometimes undefined in browsers,
      // so fall back to file.size when missing.
      const denom = e.total ?? total ?? 0;
      if (denom > 0) {
        const pct = Math.min(99, Math.round((e.loaded * 100) / denom));
        onProgress(pct);
      }
    });
  }

  // Perform upload
  await uploader.done();

  // Ensure final 100% callback
  if (typeof onProgress === "function") onProgress(100);

  return objectKey;
}


export async function uploadImageNew(file,category, type) {

  if (!file) {
    alert('Please select a file.');
    return;
  }
   const tenantId = localStorage.getItem("tenantId") || 'all';

  const randomString = uniqueString({
    tenantId,
    platform: 'stocks',
    category: category || 'category',
    name: file.name || 'ReactPhotoCollage.png',
    type: type || 'img'
  });


  const objectKey = randomString; 
  const bucketName = 'res.public';//'res.public'//'res.public.s3.amazonaws.com'; // Or actual S3 bucket name
  const arrayBuffer = await file.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);


    
  const uploadParams = {
    Bucket: bucketName,
    Key: 'uploads/'+objectKey,
    Body: uint8Array,
    ContentType: file.type || "image/jpeg"
    };
console.log("uploadParams", uploadParams);
  await s3.send(new PutObjectCommand(uploadParams));

    return objectKey;

  // const objectKey = bucketObj.objectKey + randomString; // Specify the path within the bucket (optional)
  // const uploadUrl = `${bucketObj.bucketUrl}${objectKey}`;
  // try {
  //   const uploadResponse = await fetch(uploadUrl, {
  //     method: 'PUT',
  //     body: file,
  //     headers: {
  //       'Content-Type': file.type
  //     }
  //   });

  //   if (uploadResponse.ok) {
  //     console.log('File uploaded successfully', randomString );
  //     return randomString
  //   } else {
  //     console.error('Error uploading file:', uploadResponse.statusText);
  //   }
  // } catch (error) {
  //   console.error('Error:', error);
  // }
}
export async function uploadImage(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
      
    reader.onload = async (event) => {
      try {
        // let name = "stokifyImages" + newFileName(12);
        // const body = new FormData();
        // body.append("file", new Blob([event.target.result]), name);
        // await axios.put(`${getUrls().sso}/api/uploadContent`, body )
        // resolve(name);
        const extension = file.name.split('.').pop(); // Get file extension
        const name = `stokifyImages_${newFileName(12)}.${extension}`; // Include extension in the name
        const body = new FormData();
        body.append("file", new Blob([event.target.result], { type: file.type }), name); // Ensure MIME type is correct
        
        await axios.put(`${getUrls().sso}/api/uploadContent`, body);
        resolve(name);

      } catch(e) {
        reject(e);
      }
    };
    reader.readAsDataURL(file);  
  })
  
  
}

var newFileName = function(L) { 
  var length = L || 5
  var s = '';
  var randomchar = function() {
    var n = Math.floor(Math.random() * 62);
    if (n < 10) return n; //1-10
    if (n < 36) return String.fromCharCode(n + 55); //A-Z
    return String.fromCharCode(n + 61); //a-z
  }
  while (s.length < length) s += randomchar();
  return s + (0|Math.random()*9e6).toString(36)
 }

const ImageWithBasePath = (props) => {
  // Combine the base path and the provided src to create the full image source URL
  let fullSrc;
  if(props.absolutePath) {
    fullSrc = `${props.src}`;
  } else {
    fullSrc = `${base_path}${props.src}`;
  }
  return (
    <img
      className={props.className}
      src={fullSrc}
      height={props.height}
      alt={props.alt}
      width={props.width}
      id={props.id}
    />
  );
};


export async function uploadDocument(file,category,id,docKey) {

  if (!file) {
    alert('Please select a file.');
    return;
  }
   const tenantId = localStorage.getItem("tenantId") || 'all';

  const randomString = uniqueString2({
    id,
    tenantId,
    platform: 'stocks',
    category: category || 'category',
    name: file.name,
    type: file.type || 'img',
    docKey: docKey || 'document'
  });

 console.log("randomString",randomString);
  const objectKey = randomString; 
  const bucketName = 'res.public';//'res.public'//'res.public.s3.amazonaws.com'; // Or actual S3 bucket name
  const arrayBuffer = await file.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);


    
  const uploadParams = {
    Bucket: bucketName,
    Key: 'uploads/'+objectKey,
    Body: uint8Array,
    ContentType: file.type || "image/jpeg"
    };
console.log("uploadParams", uploadParams);
  await s3.send(new PutObjectCommand(uploadParams));

    return objectKey;

}

export async function deleteDocument(objectKey) {
  if (!objectKey) {
    alert('No file key provided for deletion.');
    return false;
  }

  const bucketName = 'res.public';

  try {
    const deleteParams = {
      Bucket: bucketName,
      Key: 'uploads/' + objectKey
    };

    console.log("deleteParams", deleteParams);
    await s3.send(new DeleteObjectCommand(deleteParams));
    
    return true;
  } catch (error) {
    console.error("Error deleting file:", error);
    alert('Failed to delete the file.');
    return false;
  }
}
// Add PropTypes validation
ImageWithBasePath.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired, // Make 'src' required
  alt: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  id: PropTypes.string,
  absolutePath: PropTypes.string,
};
export const bucket = {
  s3
};
export default ImageWithBasePath;